import clsx from 'clsx'
import { useTranslation } from 'next-i18next'

import styles from './License.module.css'
import { LicenseProps } from './License.types'
import { handleLicenseClick } from './License.utils'

const License = ({
	trackId,
	source,
	className,
	...props
}: LicenseProps): JSX.Element => {
	const { t } = useTranslation(['trackrow'])

	return (
		<button
			type="button"
			className={clsx(styles.licenseButton, className)}
			onClick={() => handleLicenseClick(trackId, source)}
			{...props}
		>
			{t('track-actions.license')}
		</button>
	)
}

export default License
